<template>
	<div
		class="search-form-btns__container top-left-shadow"
		:class="{ 'show-container': show }"
	>
		<div class="forms" ref="forms">
			<div ref="ItemsContainer" class="ItemsContainer">
				<slot name="content"></slot>
			</div>
		</div>
		<div :class="{ btns: true, 'three-btn': false }">
			<el-button
				v-if="false"
				size="mini"
				type="text"
				icon="iconfont icongaojisousuo"
				@click="$emit('config')"
				>高级搜索</el-button
			>
			<el-button type="primary" size="mini" class="plr28" @click="handleSearch">
				查询
			</el-button>
			<el-button
				type="primary"
				size="mini"
				class="plr28"
				plain
				@click="handleRefresh"
			>
				重置
			</el-button>
		</div>
		<div v-if="showOpenBtn" class="open-and-close-btn" @click="handleTrigger">
			<div class="top-box"></div>
			<i
				style="font-size: 16px"
				:class="[show ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
			></i>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			showOpenBtn: true,
		};
	},
	props: {
		defaultShow: {
			type: Boolean,
			required: false,
			default: false,
		},
		needConfig: {
			type: Boolean,
			required: false,
			default: false,
		},
		manualSetShow: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	created() {
		if (this.defaultShow) {
			this.show = true;
		}
	},
	mounted() {
		this.$refs["forms"].addEventListener(
			"transitionend",
			this.handleTransitionend
		);
		this.$refs["forms"].addEventListener(
			"webkitTransitionEnd",
			this.handleTransitionend
		);
		this.ItemsContainer = this.$refs["ItemsContainer"];
		window.addEventListener("resize", this.handleShowOrHideOpenBtn);
		this.handleShowOrHideOpenBtn();
	},
	watch: {
		manualSetShow: function (value) {
			this.handleShowOrHideOpenBtn();
		},
	},
	beforeDestroy() {
		if (this.$refs["forms"]) {
			this.$refs["forms"].removeEventListener(
				"transitionend",
				this.handleTransitionend
			);
			this.$refs["forms"].removeEventListener(
				"webkitTransitionEnd",
				this.handleTransitionend
			);
		}
		window.removeEventListener("resize", this.handleShowOrHideOpenBtn);
	},
	methods: {
		handleShowOrHideOpenBtn() {
			let h = window.getComputedStyle(this.ItemsContainer).height;
			let hNum = parseInt(h);
			if (hNum > 80) {
				this.showOpenBtn = true;
			} else {
				this.showOpenBtn = false;
			}
			if (!this.show) {
				// 隐藏
				this.$refs["forms"].style.maxHeight = "50px";
				this.ItemsContainer.scrollIntoView({
					behavior: "smooth", // 平滑滚动
					block: "start", // 元素到页面顶部
				});
				this.$refs["forms"].style.overflowY = "hidden";
				// this.$emit('close')
			} else {
				this.$refs["forms"].style.maxHeight = "250px";
				if (
					parseInt(window.getComputedStyle(this.ItemsContainer).height) > 250
				) {
					this.$refs["forms"].style.overflowY = "auto";
				}
			}
		},
		handleTransitionend() {
			this.$emit("handleTransitionend");
		},
		handleTrigger() {
			this.show = !this.show;
			if (!this.show) {
				// 隐藏
				this.$refs["forms"].style.maxHeight = "50px";
				this.ItemsContainer.scrollIntoView({
					behavior: "smooth", // 平滑滚动
					block: "start", // 元素到页面顶部
				});
				this.$refs["forms"].style.overflowY = "hidden";
			} else {
				this.$refs["forms"].style.maxHeight = "250px";
				if (
					parseInt(window.getComputedStyle(this.ItemsContainer).height) > 250
				) {
					this.$refs["forms"].style.overflowY = "auto";
				}
			}
		},
		handleSearch() {
			this.$emit("search");
		},
		handleRefresh() {
			this.$emit("refresh");
		},
	},
};
</script>

<style scoped lang="scss">
$main-color: #5b8cff;

.search-form-btns__container {
	display: flex;
	background-color: #fff;
	padding: 18px 20px;
	padding-top: 2px;
	// padding-bottom: 0;
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
	position: relative;

	/* &.show-container {
    padding-bottom: 4px;
  } */
	.forms {
		flex: 1;
		overflow-y: hidden;
		transition: max-height 0.3s ease-out;
		max-height: 50px;
	}

	.btns {
		align-items: center;
		flex: 0 0 164px;
		height: 32px;
		display: flex;
		margin-top: 16px;
		// flex-direction: row-reverse;
		box-sizing: border-box;
		justify-content: space-between;
		/* .icon-open-close {
      transform: scale(0.6);
    } */
	}

	.btns.three-btn {
		flex: 0 0 206px;
	}

	.open-and-close-btn {
		width: 80px;
		height: 12px;
		border-radius: 0 0 2px 2px;
		line-height: 12px;
		text-align: center;
		position: absolute;
		cursor: pointer;
		bottom: -12px;
		left: 50%;
		display: flex;
		justify-content: center;
		align-content: center;
		transform: translateX(-40px);
		background-color: #fff;
		box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08);

		.top-box {
			width: 80px;
			height: 12px;
			position: absolute;
			top: -12px;
			left: 0;
			background-color: #fff;
		}

		i {
			font-size: 12px;
			color: #ccc;
			position: relative;
			top: -6px;
		}

		i.up {
			transform: rotate(90deg);
		}

		&:hover {
			i {
				color: $main-color;
			}
		}
	}
}

.button_text {
	font-family: PingFangSC-Regular;
	font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/searchForm/index.vue